"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkPermissionsGroup = exports.checkIsLoggedWithPermission = void 0;
const user_1 = require("../user");
const isLoggedWithPermissionResolver = (defPermissions) => (p) => {
    if (defPermissions)
        return defPermissions.includes(p);
    const { permissions } = user_1.getUserSessionStorage();
    return (permissions || []).includes(p);
};
exports.checkIsLoggedWithPermission = {
    allOf: (askedPermissions, defPermissions) => () => askedPermissions.every(isLoggedWithPermissionResolver(defPermissions)),
    oneOf: (askedPermissions, defPermissions) => () => askedPermissions.some(isLoggedWithPermissionResolver(defPermissions)),
};
const permissionGroupResolver = (p) => p();
exports.checkPermissionsGroup = {
    allOf: (askedPermissions) => askedPermissions.every(permissionGroupResolver),
    oneOf: (askedPermissions) => askedPermissions.some(permissionGroupResolver),
};
